import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import {withSnackbar} from "notistack";
import {withRouter} from "react-router";
import {Styles} from "../../../../config/design/styles";
import {connect} from "trim-redux";
import IconButton from "@material-ui/core/IconButton/IconButton";
import BorderColorRoundedIcon from '@material-ui/icons/BorderColorRounded';
import Popover from "@material-ui/core/Popover/Popover";
import Box from "@material-ui/core/Box/Box";
import HighlightOffRoundedIcon from '@material-ui/icons/HighlightOffRounded';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import {Translate} from "../../../../config/Translate";
import Tooltip from "@material-ui/core/Tooltip/Tooltip";
class HighlighterButton extends React.Component {
    state = {
        open:false,
        i_color:null
    };
    classes = this.props.classes;
    handleChangeColor(i_color){
        this.props.handleColor(i_color);
        this.setState({
            i_color,
        })
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        if(this.props.open_highlighter !== this.state.open){
            this.setState({
                open: this.props.open_highlighter
            })
        }
    }
    handleClose = () => {
        this.props.closeHighlighter()

    };
    render(){
        let {open,i_color} = this.state;
        return (
            <div>
                <Popover
                    className={this.classes.fontSizePopOver}
                    open={open}
                    anchorReference="anchorPosition"
                    anchorPosition={{ top: 50, left: 20 }}
                    onClose={() => this.handleClose()}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'center',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'center',
                    }}
                >
                    <Box p={2}>
                        <IconButton
                            size="small"
                            onClick={() => this.handleChangeColor('yellow')}
                        >
                            <FiberManualRecordIcon style={{color:"yellow"}}/>
                        </IconButton>
                        <IconButton
                            size="small"
                            onClick={() => this.handleChangeColor('red')}
                        >
                            <FiberManualRecordIcon style={{color:"red"}}/>
                        </IconButton>
                        <IconButton
                            size="small"
                            onClick={() => this.handleChangeColor('blue')}
                        >
                            <FiberManualRecordIcon style={{color:"blue"}}/>
                        </IconButton>
                        <IconButton
                            size="small"
                            onClick={() => this.handleChangeColor('green')}
                        >
                            <FiberManualRecordIcon style={{color:"green"}}/>
                        </IconButton>
                    </Box>
                </Popover>
            </div>

        );
    }
}
const mstp = state => ({
    user: state.user,
});
export default withSnackbar(withRouter(withStyles(Styles)(connect(mstp)(HighlighterButton))));